import { Component } from '@angular/core';

@Component({
  selector: 'app-permission-role-user-add',
  templateUrl: './role-add.component.html',
  styleUrls: ['./role-add.component.css']
})
export class RoleAddComponent {

}
